import { i18n } from "@/i18n";

const wordClassTranslationMap = {
  "adj.": i18n.global.t("article.polCurrentDada.wordclass.adj"),
  "adj.komp.": i18n.global.t("article.polCurrentDada.wordclass.adjKomp"),
  "adj.pl.": i18n.global.t("article.polCurrentDada.wordclass.adjPl"),
  "adj.sup.": i18n.global.t("article.polCurrentDada.wordclass.adjSup"),
  "adv.": i18n.global.t("article.polCurrentDada.wordclass.adv"),
  "adv.komp.": i18n.global.t("article.polCurrentDada.wordclass.advKomp"),
  "adv.sup.": i18n.global.t("article.polCurrentDada.wordclass.advSup"),
  artikel: i18n.global.t("article.polCurrentDada.wordclass.artikel"),
  "fork.": i18n.global.t("article.polCurrentDada.wordclass.fork"),
  "formelt subjekt": i18n.global.t("article.polCurrentDada.wordclass.formeltSubjekt"),
  infinitivmærke: i18n.global.t("article.polCurrentDada.wordclass.infinitivmærke"),
  "konj.": i18n.global.t("article.polCurrentDada.wordclass.konj"),
  lydord: i18n.global.t("article.polCurrentDada.wordclass.lydord"),
  orddel: i18n.global.t("article.polCurrentDada.wordclass.orddel"),
  "pron.": i18n.global.t("article.polCurrentDada.wordclass.pron"),
  "pron.pl.": i18n.global.t("article.polCurrentDada.wordclass.pronPl"),
  "prop.": i18n.global.t("article.polCurrentDada.wordclass.prop"),
  "propr.": i18n.global.t("article.polCurrentDada.wordclass.propr"),
  "propr.best.": i18n.global.t("article.polCurrentDada.wordclass.proprBest"),
  "propr.pl.": i18n.global.t("article.polCurrentDada.wordclass.proprPl"),
  "propr.pl.best.": i18n.global.t("article.polCurrentDada.wordclass.proprPlBest"),
  præfiks: i18n.global.t("article.polCurrentDada.wordclass.præfiks"),
  "præp.": i18n.global.t("article.polCurrentDada.wordclass.præp"),
  "sb.": i18n.global.t("article.polCurrentDada.wordclass.sb"),
  "sb.pl.": i18n.global.t("article.polCurrentDada.wordclass.sbPl"),
  "sb.best.": i18n.global.t("article.polCurrentDada.wordclass.sbBest"),
  "sb.pl.best.": i18n.global.t("article.polCurrentDada.wordclass.sbPlBest"),
  talord: i18n.global.t("article.polCurrentDada.wordclass.talord"),
  udråbsord: i18n.global.t("article.polCurrentDada.wordclass.udråbsord"),
  "vb.": i18n.global.t("article.polCurrentDada.wordclass.vb")
};

export const findWordclass = (wordclass) => {
  const wordClasses = wordclass.split(",").filter((w) => w !== "");

  const foundWordClasses = [];
  for (let i = 0; i < wordClasses.length; i++) {
    const wordClass = wordClasses[i].trim();

    // Try 1:1 and find the wordclass
    const translatedWordclass = wordClassTranslationMap[wordClass];
    if (translatedWordclass) {
      foundWordClasses.push(translatedWordclass);
      continue;
    }

    // Try and find the wordclass without suffixes
    const translateWordClassWithoutSuffix = findWordClassWithoutSuffix(wordClass);
    if (translateWordClassWithoutSuffix) {
      foundWordClasses.push(translateWordClassWithoutSuffix);
      continue;
    }

    // Nothing found return input
    foundWordClasses.push(wordClass);
  }

  return foundWordClasses.join(", ");
};

const findWordClassWithoutSuffix = (wordClass) => {
  // Match : and ; and " " space
  const suffixRegex = /[:; ]/g;
  // Use regex to sanitize text without :;
  const wordClassWithoutSuffix = wordClass.replaceAll(suffixRegex, "");
  const translatedWordClassWithoutSuffix = wordClassTranslationMap[wordClassWithoutSuffix];

  if (translatedWordClassWithoutSuffix) {
    return translatedWordClassWithoutSuffix;
  }

  return null;
};
